export default __webpack_public_path__ + "static/media/diagnosis.f0454502.mp4";